<template>
  <footer class="footer" data-aos="fade-up" data-aos-once="true">
    <div class="container">
      <div class="columns content is-centered is-gapless" style="margin-bottom:0;">
        <div class="column is-4 has-text-centered" style="font-weight:lighter;font-size:0.8em;">
          <span class="column-link"
            :class="{ 'is-active': $route.name === 'landing' }">
            <a href="/?anchor=gallery-container" @click="$event.preventDefault();onScrollTo('landing', 'gallery-container')">
              Gallery
            </a>
          </span>&nbsp;&nbsp;|&nbsp;&nbsp;
          <span class="column-link"
            :class="{ 'is-active': $route.name === 'about' }">
            <router-link href="/about" to="about">About</router-link>
          </span>&nbsp;&nbsp;|&nbsp;&nbsp;
          <span class="column-link"
            :class="{ 'is-active': $route.name === 'locate' }">
            <router-link href="/locate" to="locate">Locate</router-link>
          </span>
        </div>
      </div>
      <div class="columns content is-centered is-gapless">
        <p class="column is-4 has-text-centered" style="font-weight:lighter;">
          &copy; {{ year }} Lasting Impressions Sdn Bhd (218733-H). All Rights Reserved.
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'footer',
  components: {
  },
  data () {
    return {
      year: 2017
    }
  },
  methods: {
    onScrollTo (name, target) {
      if (this.$route.name !== name) {
        this.$router.replace({ name: name, query: { anchor: target } })
      } else {
        this.$scrollTo('#' + target)
      }
    }
  },
  beforeCreate () {
  },
  created () {
  },
  beforeMount () {
  },
  mounted () {
    this.year = (new Date()).getFullYear()
  }
}
</script>

<style lang="scss">
@import "../assets/app_setting.scss";

footer, .footer {
  background-color: #EAEBE0;
}

footer {
  .columns {
    .column {
      .column-link a {
        color: $color-gray;

        &:hover {
          color: $color-gold;
        }
      }
    }
  }

  .content p {
    font-size: 0.8em;
    text-align: center;
  }
}

</style>



// WEBPACK FOOTER //
// Footer.vue?543a1235